// see docs/modules/hero.md#import-swiper-from-swiper
import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

(function () {
    // only a fallback -- the real value comes from PHP, so the CSS custom
    // property driving the progress line and this timer share one source
    const FALLBACK_DURATION_MS = 8000;
    const FADE_SPEED_MS = 800;

    const hero = document.querySelector('[data-jb-hero]');
    if (!hero) return;

    const slider = hero.querySelector('.jb-hero__slider');
    if (!slider) return;

    const tabs = [...hero.querySelectorAll('[data-jb-hero-tab]')];
    const duration = parseInt(hero.dataset.jbHeroDuration, 10) || FALLBACK_DURATION_MS;

    // see docs/modules/hero.md#const-synctabs-activeindex
    const syncTabs = (activeIndex) => {
        tabs.forEach((tab, index) => {
            tab.classList.remove('is-active', 'is-played');

            if (index < activeIndex) {
                tab.classList.add('is-played');
            }

            tab.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });

        const activeTab = tabs[activeIndex];
        if (!activeTab) return;

        void activeTab.offsetWidth;
        activeTab.classList.add('is-active');
    };

    const swiper = new Swiper(slider, {
        modules: [Autoplay, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: FADE_SPEED_MS,

        // rewind, not loop: loop clones slides, which desynchronises realIndex
        // from the data-jb-hero-tab indexes the nav row is built from
        rewind: true,

        autoplay: {
            delay: duration,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },

        on: {
            slideChange: (instance) => syncTabs(instance.realIndex),

            // Swiper pauses on hover and when the tab is backgrounded; the
            // progress line follows through this class rather than its own handlers
            autoplayPause: () => hero.classList.add('is-paused'),
            autoplayResume: () => hero.classList.remove('is-paused'),
        },
    });

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            swiper.slideTo(index);

            if (swiper.autoplay) {
                swiper.autoplay.start();
            }
        });
    });
})();
